import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import JsonLd from "../../../../../base/others/json-ld/index.js";
import Title from "../../../../../base/text/title/index.js";
import BenefitsCard from "../../../../cards/benefits-card/views/mobile/index.js";
import ProductCard from "../../../../cards/product-card/views/mobile/index.js";
import CardSkeletonMobile from "../../../../cards/product-card/views/mobile/card-skeleton/index.js";
import { getTitle } from "../utils.js";
import { genKey } from "../../../../../../helpers/keys.js";
import ButtonViewMore from "./button-view-more/index.js";
import * as S from "./styled.js";
const CarouselCardProductMobile = ({ props  })=>{
    const { ldjson , items =[] , className ='' , link , config , isLoading =false , defaultImage ={
        src: ''
    } , isFirstComponent =false , benefits  } = props ?? {};
    const title = getTitle(props?.title);
    const skeleton = useMemo(()=>new Array(5).fill(undefined).map((_, index)=>/*#__PURE__*/ _jsx(CardSkeletonMobile, {}, genKey(index))), []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                className: "carousel-title",
                ...title
            }),
            /*#__PURE__*/ _jsxs(S.CarouselProductWrapper, {
                "data-testid": "CarouselProduct",
                className: className,
                children: [
                    benefits && /*#__PURE__*/ _jsx(BenefitsCard, {
                        ...benefits
                    }),
                    isLoading ? skeleton : items.map((item)=>{
                        const generalConfig = {
                            ...item.config,
                            ...config
                        };
                        const literals = {
                            ...item.config?.literals,
                            ...config?.literals
                        };
                        return /*#__PURE__*/ _jsx(ProductCard, {
                            ...item,
                            config: {
                                ...generalConfig,
                                literals,
                                isFirstComponent
                            },
                            defaultImage: defaultImage
                        }, genKey(item));
                    }),
                    !!link && !!link.href && !isLoading && /*#__PURE__*/ _jsx(ButtonViewMore, {
                        link: link,
                        content: config?.literals?.viewMore ?? link.title
                    }),
                    ldjson?.scripts?.map((script)=>/*#__PURE__*/ _jsx(JsonLd, {
                            structuredData: script
                        }, genKey(script)))
                ]
            })
        ]
    });
};
export default CarouselCardProductMobile;

//# sourceMappingURL=index.js.map